import { useLazyQuery, useMutation } from "@apollo/client";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../../CommonFunction/CustomUseFormSubmission";
import { ClearSpecificForm } from "../../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CreateSalesInvoiceType,
  Edit_Tax_Group,
  Get_Tax_Group_By_Id,
} from "../../../../../Utils/AllPagesQuriesAndMutations";
import useFetchFormFields from "../../../../custom_hooks/useFetchFormFields";
import { useGetPageData } from "../../../../custom_hooks/useGetPageData";
import Button from "../../../Button/Button";
import { Confirm } from "../../../Confirmation/Confirm";
import { FormInputSectionComponent } from "../../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateValueForm } from "../../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../../Reactportal/ModalContext";
import PortalFooter from "../../../Reactportal/PortalFooter";
import Reactportal from "../../../Reactportal/Reactportal";
import { ErrorToast } from "../../../ToastComponent/RectHotToast";
import "../.././FormComponent.scss";
import "./AddSalesInvoiceType.scss";
import { TaxSelection } from "./TaxSelection";

const AddTaxGroup = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  ReferenceFieldName = [],
  ReferFormKey = "",
}) => {
  const Form_Key = "Tax_Group";
  const formRef = useRef({});
  const { pushModal, popModal, getTopModal } = useModalContext();
  const [toggle, settoggle] = useState(show ? show : false);
  const [TaxType, setTaxType] = useState("");
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Tax_Group?.Selected_Row;
  const SelectedTaxes = fielddataRedux?.Select_Tax?.Selected_Rows;
  const [allFieldsData, setAllFieldsData] = useState({});
  const { fields } = useGetPageData();
  const [selectedRows, setSelectedRows] = useState([]);
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [FormData, setFormdata] = useState({});
  const [ShowTax, setShowTax] = useState(false);

  //Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [CreatingData, { loading: CreateSalesInvoiceLoading }] = useMutation(CreateSalesInvoiceType);

  const [GetSalesexpensiveids] = useLazyQuery(Get_Tax_Group_By_Id, {
    fetchPolicy: "network-only",
  });

  const [EditingData, { loading: editSalesInvoiceLoading }] = useMutation(Edit_Tax_Group(fields));

  // const [DeletingData, { loading: DeleteSalesInvoiceTypeLoading }] = useMutation(Delete_Sales_Invoice);

  const SalesInvoiceTypeLoadingState = editSalesInvoiceLoading || CreateSalesInvoiceLoading;

  const dispatch = useDispatch();
  useEffect(() => {
    pushModal(Form_Key);
  }, []);
  useEffect(() => {
    if (TypeOfPortal !== "Add") {
      getFormSectionAndFields().then(() => {
        GetSalesexpensiveids({
          variables: {
            id: fielddata?._id,
          },
        }).then(({ data }) => {
          let SalesInvoiceData = { ...data?.getTaxGroupByID };
          console.log(SalesInvoiceData.Tax_Percentage?.Tax_Percentage);
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Tax_Rate: {
                  ...SalesInvoiceData?.Tax_Rate,
                },
              },
            },
          });
          if (SalesInvoiceData && SalesInvoiceData.Tax_Rate) {
            SalesInvoiceData.Tax_Rate = SalesInvoiceData?.Tax_Rate?.Tax_Percentage;
          }
          const payloadData = {
            key: "Select_Tax",
            data: {
              Selected_Rows: SalesInvoiceData?.Selected_Taxes,
            },
          };
          dispatch({ type: "UNIQUE_TABLE_LIST", payload: payloadData });
          setAllFieldsData(SalesInvoiceData);
          updateValueForm(formRef, SalesInvoiceData);
        });
      });
    } else {
      setAllFieldsData({});
    }
  }, [fielddata]);

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Tax_Group?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    console.log(FormData);
  }, [FormData]);

  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = FormData;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);
  const BranchMutations = {
    CreatingData,
    EditingData,
  };

  const submit = async (closeAction) => {
    let Name = ReferenceFieldName[0]?.name;
    formData.Tax_Type = TaxType;
    formData.Tax_Rate = FormDataFromRedux?.MasterData[Form_Key]?.Tax_Rate?._id;
    formData.Selected_Taxes = SelectedTaxes?.map((el) => el._id);
    const mutationFunction = getMutationFunction(operationType, BranchMutations);

    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        PageName: Form_Key,
        OnSuccess: (res) => {
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data: {
                [Name]: res?.data?.editSalesInvoiceType,
              },
            },
          });
          handleFormReset(formRef);
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => {
        setAllFieldsData();
        handleFormReset(formRef);
      },
      onSuccess: () => { },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = useCallback(() => {
    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
    popModal(Form_Key);
  });

  const SaveandCloseForAdd = () => {
    submit("Close");
  };

  if (TypeOfPortal === "Delete") {
    return (
      <Confirm submit={submit} settoggle={settoggle} toggle={toggle} loadingState={SalesInvoiceTypeLoadingState} />
    );
  }

  return (
    <div>
      <Reactportal open={toggle} onClose={Closeformfunction} TypeOfPortal={TypeOfPortal + " " + "Tax Group"}>
        <div className="SalesContainerr">
          <div className="salesInvoceContainer">
            {inputFields?.length > 0 ? (
              inputFields.map((e) => (
                <FormInputSectionComponent
                  key={e.id}
                  inputfields={e.fields}
                  Type={e.name}
                  fielddata={allFieldsData}
                  TypeOfPortal={TypeOfPortal}
                  onhandleFormikChange={HanldeChangeonForm}
                  formkey={Form_Key}
                  formRef={formRef}
                />
              ))
            ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
              <p style={{ textAlign: "center" }}>No form fields available.</p>
            ) : null}

            {inputFields?.length > 0 && (
              <>
                <br />
                <Button
                  name="modalbutton"
                  text={"Select Tax"}
                  action={() => {
                    setShowTax(true);
                  }}
                />
              </>
            )}
            {ShowTax && (
              <TaxSelection
                show={ShowTax}
                setShowTax={() => setShowTax(false)}
                setTaxType={setTaxType}
                SelectedTaxes={SelectedTaxes}
              />
            )}
            <div>
              {SelectedTaxes?.map((el) => (
                <>
                  <div>{el.Tax_Name}</div>
                </>
              ))}
            </div>
          </div>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}

          Form_key={Form_Key}
          submitType={submitType}
          SaveAndClose={TypeOfPortal === "Add" ? SaveandCloseForAdd : submit}
          handleformclose={() => {
            Closeformfunction();
          }}
          loadingState={SalesInvoiceTypeLoadingState}
        />
      </Reactportal>
    </div>
  );
};

export default AddTaxGroup;
